import OrdersView from "./orders-view.js";

export default [
	{
		path: "",
		component: OrdersView,
	},
];
